import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CloseButton, EllipsisText, factory, Group, InputBase, useProps } from '@coveord/plasma-mantine';
import { IconChevronDown } from '@coveord/plasma-react-icons';
import { useTopBarContext } from './TopBarContext.js';
var defaultProps = {};
export var TopBarSelect = factory(function(_props) {
    var ctx = useTopBarContext();
    var _useProps = useProps('TopBarSelect', defaultProps, _props), label = _useProps.label, onClick = _useProps.onClick, onClear = _useProps.onClear, value = _useProps.value, placeholder = _useProps.placeholder, badge = _useProps.badge, disabled = _useProps.disabled, ref = _useProps.ref, others = _object_without_properties(_useProps, [
        "label",
        "onClick",
        "onClear",
        "value",
        "placeholder",
        "badge",
        "disabled",
        "ref"
    ]);
    var isClearable = !!onClear && !!value;
    return /*#__PURE__*/ _jsx(InputBase, _object_spread_props(_object_spread({
        rightSection: isClearable && !!value ? /*#__PURE__*/ _jsx(CloseButton, {
            "aria-label": "Clear ".concat(label),
            onClick: onClear,
            disabled: disabled
        }) : /*#__PURE__*/ _jsx(IconChevronDown, {
            height: 16
        }),
        component: "button",
        type: "button",
        pointer: true,
        disabled: disabled,
        rightSectionPointerEvents: isClearable ? 'all' : 'none',
        variant: "unstyled",
        onClick: onClick,
        label: label,
        ref: ref,
        classNames: {
            root: ctx.getStyles('select').className,
            wrapper: ctx.getStyles('selectWrapper').className,
            label: ctx.getStyles('selectLabel').className,
            input: ctx.getStyles('selectInput').className
        }
    }, others), {
        children: /*#__PURE__*/ _jsxs(Group, _object_spread_props(_object_spread({
            gap: "xs"
        }, ctx.getStyles('selectValue')), {
            wrap: "nowrap",
            children: [
                /*#__PURE__*/ _jsx(EllipsisText, {
                    maw: 325,
                    children: value !== null && value !== void 0 ? value : placeholder
                }),
                /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({}, ctx.getStyles('selectBadge')), {
                    children: badge
                }))
            ]
        }))
    }));
});
TopBarSelect.displayName = 'TopBar.Select';

//# sourceMappingURL=TopBarSelect.js.map